import React, {Component} from 'react';
import {connect} from 'react-redux';
import PendingChangesTab from "../../components/ApplicationPolicy/pendingChangesTab";
import {
    changePendingChangesStore,
    changePendingChangeState,
    changePendingChangeStateFailed,
    changePendingChangeStateSuccess, clearPendingChangesErrorState,
    fetchPendingChanges, moderatePendingChange
} from "../../actions/pendingChanges";
import {fetchEditingSettings} from "../../actions/editingSettings";
import PendingChangeItem from "../../components/ApplicationPolicy/pendingChangeItem";
import moment from "moment";
import {
    flattenQuestions,
    getAnswersOfMedicalExpertFeesQuestion,
    getAnswersOFOpponentQuestionGroup,
    getAnswersOfQuestionAndItsAncestors,
    getPendingAnswersOfMedicalExpertFeesQuestion,
    getPendingAnswersOFOpponentQuestionGroup,
    getPendingAnswersOfQuestionAndItsAncestors,
    getTriggeredQuestionFromQuestionsMayBeTriggered,
    flattenQuestion
} from "../../helpers/questions/functions";
import {getApprovalSettingById, mapApprovalSettingToQuestion} from "../../helpers/approvalSettings/functions";
import AnsweredQuestion from "../../components/ApplicationPolicy/answeredQuestion";
import {ANSWER_UPDATE_ACTION} from "../../helpers/variables";
import {requestGetSelectedApplication, requestGetSolicitorGroupWorkSources} from "../../actions/newApplication";
import {requestBreachCausationCp} from "../../actions/breachCausationCp";
import {requestApplicationAttachment} from "../../actions/applicationPolicy";
import {ESTIMATED_MEDICAL_EXPERT_FEES_MN, OPPONENT_NAME_MN, OPPONENT_QUESTION_NAME_MAPPING, WORK_SOURCE_ID_MN} from "../../helpers/constants";


class PendingChangesTabHOC extends Component {

    constructor(props){
        super(props);
        this.state = {
            isRejectModalOpen: false,
            rejectReason: undefined,
            selectedRejectItem: {}
        }
    }

    componentDidMount() {
        this.props.fetchPendingChanges({applicationId: this.props.applicationId});
        this.props.fetchEditingSettings();
        this.props.requestPossibleWorkSources(this.props.application.solicitorGroupId);
        this.props.requestBreachCausationCp();
    }

    componentDidUpdate(prevProps) {
        if(
            !this.props.patchingId && prevProps.patchingId
            && !this.props.errorMessage

        ){
            this.state.selectedRejectItem.datum && this.closeRejectModal();
            this.props.getSelectedApplication(this.props.application.id);
        }
    }

    onAccept = (item) => {
        const sendBody = {
            applicationAnswerPendingChangeId: item.datum.id,
            moderatedReason: null,
            isApproved: true
        };

        this.props.moderatePendingChange({sendBody});
    };

    onReject = (item) => {
        this.setState({...this.state, isRejectModalOpen: true, selectedRejectItem: item});
    };

    onConfirmReject = () => {
        const sendBody = {
            applicationAnswerPendingChangeId: this.state.selectedRejectItem.datum.id,
            moderatedReason: this.state.rejectReason ? this.state.rejectReason : null,
            isApproved: false
        };

        this.props.moderatePendingChange({sendBody});
    };

    closeRejectModal = () => {
        this.setState({
            ...this.state,
            isRejectModalOpen: false,
            rejectReason: undefined,
            selectedRejectItem: {}
        });
        this.props.clearPendingChangesErrorState();
    };

    onRejectReasonChange = (name, value) => { this.setState({...this.state, rejectReason: value}) };

    addOpponentAnsweredQuestionMachineNames = (answeredQuestionMachineNames) => {
        if(answeredQuestionMachineNames &&
            (this.state.opponentAnsweredQuestionMachineNames?.length !== this.props.opponentAnsweredQuestionMachineNames?.length)){
            this.setState( (state) => ({
                ...state,
                opponentAnsweredQuestionMachineNames: answeredQuestionMachineNames         
            }))  
    
            for (const questionMachineName in OPPONENT_QUESTION_NAME_MAPPING) {
                if (!answeredQuestionMachineNames.includes(questionMachineName)) {
                    this.setState((state) => ({
                        ...state,
                        opponent: {
                            ...this.state.opponent,
                            [OPPONENT_QUESTION_NAME_MAPPING[questionMachineName]]: null
                        }
                    }));
                }
            }
        }
    }; 

    getPendingChangesItems = () => {
        const items = [];
        const flattenedQuestions = flattenQuestions(this.props.application.questionsDtos);
        this.props.pendingChanges.forEach(pendingChange => {
            try {
                //  find corresponding question - field - table
                const approvalSetting = getApprovalSettingById(this.props.approvalSettings, pendingChange.applicationAnswerApprovalSettingId);
                const question = mapApprovalSettingToQuestion(approvalSetting, flattenedQuestions);
                // find previous question current answer
                let currentAnswer = null;
                if(pendingChange.applicationUpdateAction === ANSWER_UPDATE_ACTION.ADD){
                    currentAnswer = null;
                } else {
                    const currentFormData = getAnswersOfQuestionAndItsAncestors(question, this.props.application);
                    const triggered = getTriggeredQuestionFromQuestionsMayBeTriggered({...this.props.formData,...currentFormData}, flattenQuestion(question),flattenedQuestions);
                    currentAnswer =  (
                        <div className={"form-horizontal"}>
                            <AnsweredQuestion
                                key={`currentAnswer-${question.id}`}
                                onAttachmentRequest={(attachment) => {
                                    this.props.requestApplicationAttachment({
                                        applicationId: this.props.application.id,attachmentId:attachment.id,
                                        relativeUrl: attachment.relativeUrl
                                    });
                                }}
                                attachments={this.props.application.attachments}
                                smallHeader
                                isPlain
                                formData={currentFormData}
                                opponent={question.machineName === OPPONENT_NAME_MN 
                                    ? getAnswersOFOpponentQuestionGroup(pendingChange.entityId, this.props.application) 
                                    : {}
                                }
                                question={question.machineName === WORK_SOURCE_ID_MN 
                                    ? {...question, options: this.props.solicitorGroupWorkSources} 
                                    : question
                                }
                                questionAnswer={currentFormData[question.id]}
                                medicalExpertFees={question.machineName === ESTIMATED_MEDICAL_EXPERT_FEES_MN 
                                    ? [getAnswersOfMedicalExpertFeesQuestion(pendingChange.entityId, this.props.application)] 
                                    : []
                                }
                                breachCausationCp={this.props.breachCausationCp}
                                addOpponentAnsweredQuestionMachineNames={this.addOpponentAnsweredQuestionMachineNames}
                                application={this.props.application}
                                opponentQuestions={this.props.opponentQuestions}
                                isApplicationTab={false}
                            />
                            {triggered.length > 0 ? (
                                triggered.map((triggered) => (
                                    <AnsweredQuestion
                                        key={`currentAnswer-triggered-${triggered.id}`}
                                        onAttachmentRequest={(attachment) => {
                                            this.props.requestApplicationAttachment({
                                                applicationId: this.props.application.id,attachmentId:attachment.id,
                                                relativeUrl: attachment.relativeUrl
                                            });
                                        }}
                                        attachments={this.props.application.attachments}
                                        smallHeader
                                        isPlain
                                        formData={currentFormData}
                                        opponent={triggered.machineName === OPPONENT_NAME_MN 
                                            ? getAnswersOFOpponentQuestionGroup(pendingChange.entityId, this.props.application) 
                                            : {}
                                        }
                                        question={triggered.machineName === WORK_SOURCE_ID_MN 
                                            ? {...triggered, options: this.props.solicitorGroupWorkSources} 
                                            : triggered
                                        }
                                        questionAnswer={currentFormData[triggered.id]}
                                        medicalExpertFees={question.machineName === ESTIMATED_MEDICAL_EXPERT_FEES_MN 
                                            ? [getAnswersOfMedicalExpertFeesQuestion(pendingChange.entityId, this.props.application)] 
                                            : []
                                        }
                                        breachCausationCp={this.props.breachCausationCp}
                                        addOpponentAnsweredQuestionMachineNames={this.addOpponentAnsweredQuestionMachineNames}
                                        application={this.props.application}
                                        opponentQuestions={this.props.opponentQuestions}
                                        isApplicationTab={false}
                                    />
                                ))
                            ) : null}
                        </div>
                    );
                }
                // find pending change
                let pendingAnswer = null;
                if(pendingChange.applicationUpdateAction === ANSWER_UPDATE_ACTION.REMOVE){
                    pendingAnswer = null;
                } else {
                    const formData = getPendingAnswersOfQuestionAndItsAncestors(question, pendingChange, this.props.application);
                    const triggered = getTriggeredQuestionFromQuestionsMayBeTriggered({...this.props.formData,...formData}, flattenQuestion(question),flattenedQuestions);
                    pendingAnswer =  (
                        <div className={"form-horizontal"}>
                            <AnsweredQuestion
                                key={`pendingAnswer-${question.id}`}
                                attachments={pendingChange.applicationAnswerPendingChangeAttachmentDtos}
                                smallHeader
                                isPlain
                                formData={formData}
                                opponent={question.machineName === OPPONENT_NAME_MN 
                                    ? getPendingAnswersOFOpponentQuestionGroup(pendingChange.entityId, pendingChange, this.props.application) 
                                    : {}
                                }
                                question={question.machineName === WORK_SOURCE_ID_MN 
                                    ? {...question, options: this.props.solicitorGroupWorkSources} 
                                    : question
                                }
                                questionAnswer={formData[question.id]}
                                medicalExpertFees={question.machineName === ESTIMATED_MEDICAL_EXPERT_FEES_MN 
                                    ? [getPendingAnswersOfMedicalExpertFeesQuestion(pendingChange.entityId, pendingChange, this.props.application)] 
                                    : []
                                }
                                breachCausationCp={this.props.breachCausationCp}
                                addOpponentAnsweredQuestionMachineNames={this.addOpponentAnsweredQuestionMachineNames}
                                application={this.props.application}
                                opponentQuestions={this.props.opponentQuestions}
                                isApplicationTab={false}
                            />
                            {triggered.length > 0 ? (
                                triggered.map((triggered) => (
                                    <AnsweredQuestion
                                        key={`pendingAnswer-triggered-${triggered.id}`}
                                        onAttachmentRequest={(attachment) => {
                                            this.props.requestApplicationAttachment({
                                                applicationId: this.props.application.id,attachmentId:attachment.id,
                                                relativeUrl: attachment.relativeUrl
                                            });
                                        }}
                                        attachments={this.props.application.attachments}
                                        smallHeader
                                        isPlain
                                        formData={formData}
                                        opponent={triggered.machineName === OPPONENT_NAME_MN 
                                            ? getAnswersOFOpponentQuestionGroup(pendingChange.entityId, this.props.application) 
                                            : {}
                                        }
                                        question={triggered.machineName === WORK_SOURCE_ID_MN 
                                            ? {...triggered, options: this.props.solicitorGroupWorkSources} 
                                            : triggered
                                        }
                                        questionAnswer={formData[triggered.id]}
                                        medicalExpertFees={question.machineName === ESTIMATED_MEDICAL_EXPERT_FEES_MN 
                                            ? [getAnswersOfMedicalExpertFeesQuestion(pendingChange.entityId, this.props.application)] 
                                            : []
                                        }
                                        breachCausationCp={this.props.breachCausationCp}
                                        addOpponentAnsweredQuestionMachineNames={this.addOpponentAnsweredQuestionMachineNames}
                                        application={this.props.application}
                                        opponentQuestions={this.props.opponentQuestions}
                                        isApplicationTab={false}
                                    />
                                ))
                            ) : null}
                        </div>
                    );
                }
                // construct the datum
                const item = {
                    id: pendingChange.id,
                    body: <PendingChangeItem current={currentAnswer} pending={pendingAnswer} />,
                    issuer: pendingChange.requestedByFullName,
                    date: moment(pendingChange.revisionDate).format("DD/MM/YYYY - HH:mm:ss"),
                    label: `Pending change (${pendingChange.applicationUpdateAction})`,
                    datum: pendingChange
                };
                items.push(item);
            } catch (e) {
                items.push({id: "", body: "error occurred while parsing.", issuer: "", date: "", label: "Error"});
            }
        });


        return items;

    };

    render(){
        const pendingChangeItems = this.getPendingChangesItems();
        return (
            <PendingChangesTab
                {...this.props}
                onConfirmReject={this.onConfirmReject}
                onAccept={this.onAccept}
                onReject={this.onReject}
                closeRejectModal={this.closeRejectModal}
                isRejectModalOpen={this.state.isRejectModalOpen}
                rejectReason={this.state.rejectReason}
                onRejectReasonChange={this.onRejectReasonChange}
                pendingChangeItems={pendingChangeItems}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userRoles: state.user.loggedInUser.roles,
        pendingChanges: state.pendingChanges.pendingChanges,
        fetchingPendingChanges: state.pendingChanges.fetchingPendingChanges,
        fetchingEditingSettings: state.editingSettings.fetchingEditingSettings,
        fetchingSelectedApp: state.newApplication.fetchingSelectedApp,
        patchingId: state.pendingChanges.patchingId,
        errorMessage: state.pendingChanges.errorMessage,
        errorItemId: state.pendingChanges.errorItemId,
        applicationId: state.newApplication.selectedApplication.id,
        approvalSettings: state.editingSettings.approvalSettings,
        application: state.newApplication.selectedApplication,
        solicitorGroupWorkSources: state.newApplication.solicitorGroupWorkSources,
        breachCausationCp: state.breachCausationCp,
        questions: state.newApplication.questions,
        formData: state.newApplication.formData,
        questionsTriggeredByQuestions: state.newApplication.questionsTriggeredByQuestions,
        opponentAnsweredQuestionMachineNames: state.opponentAnsweredQuestionMachineNames,
        opponentQuestions: state.newApplication.opponentQuestions,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPendingChanges: (payload) => {
            dispatch(fetchPendingChanges(payload))
        },
        changePendingChangeStore: (payload) => {
            dispatch(changePendingChangesStore(payload))
        },
        moderatePendingChange: (payload) => {
            dispatch(moderatePendingChange(payload))
        },
        changePendingChangeState: (payload) => {
            dispatch(changePendingChangeState(payload))
        },
        changePendingChangeStateSuccess: (payload) => {
            dispatch(changePendingChangeStateSuccess(payload))
        },
        changePendingChangeStateFailed: (payload) => {
            dispatch(changePendingChangeStateFailed(payload))
        },
        fetchEditingSettings: (payload) => {
            dispatch(fetchEditingSettings(payload))
        },
        requestPossibleWorkSources: (payload) => {
            dispatch(requestGetSolicitorGroupWorkSources(payload))
        },
        requestBreachCausationCp: () => {
            dispatch(requestBreachCausationCp())
        },
        clearPendingChangesErrorState: (payload) => {
            dispatch(clearPendingChangesErrorState(payload))
        },
        getSelectedApplication: (id) => {
            dispatch(requestGetSelectedApplication(id))
        },
        requestApplicationAttachment: (payload) => {
            dispatch(requestApplicationAttachment(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingChangesTabHOC);